import { render } from "./AtencionesPorEspecialidad.vue?vue&type=template&id=3f08d716&scoped=true"
import script from "./AtencionesPorEspecialidad.vue?vue&type=script&lang=js"
export * from "./AtencionesPorEspecialidad.vue?vue&type=script&lang=js"

import "./AtencionesPorEspecialidad.vue?vue&type=style&index=0&id=3f08d716&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f08d716"]])

export default __exports__